const manifestos = document.querySelectorAll('.js-manifesto');
const urlParams = new URLSearchParams(window.location.search);

manifestos.forEach((manifesto, index) => {
  // Manifesto index is +1 to make it start with 1 instead of 0
  const manifestoIndex = index + 1;

  initializeManifesto(manifesto, manifestoIndex);
});

function initializeManifesto(manifesto, manifestoIndex) {
  let activeTabIndex = parseInt(urlParams.get(`manifesto-${manifestoIndex}-tab`));
  if (activeTabIndex) {
    // Active tab index is -1 because the index is upped by one to make it start with 1 instead of 0
    activeTabIndex - 1;
  }

  if (activeTabIndex >= 0 && (typeof requestWasPost === 'undefined' || !requestWasPost)) {
    manifesto.scrollIntoView();
  }

  const menuLinks = manifesto.querySelectorAll('.js-manifesto-menu-link');

  menuLinks.forEach((menuLink, index) => {
    const itemId = menuLink.href.split('#')[1];

    // Tab index is +1 to make it start with 1 instead of 0
    var tabIndex = index + 1;

    if ((tabIndex == 1 && !activeTabIndex) || tabIndex == activeTabIndex) {
      menuLink.classList.add('manifesto__menu--active');
      manifesto.querySelector(`#${itemId}`).classList.add('manifesto__content--visual');
      manifesto.querySelector(`#${itemId}-img`).classList.add('manifesto-images--visual');
    }

    menuLink.addEventListener('click', (e) => {
      e.preventDefault();

      var url = new URL(window.location);

      url.searchParams.set(`manifesto-${manifestoIndex}-tab`, tabIndex);
      window.history.replaceState({}, '', url);

      menuLinks.forEach((menuLink) => {
        menuLink.classList.remove('manifesto__menu--active');
      });

      menuLink.classList.add('manifesto__menu--active');

      manifesto
        .querySelector('.manifesto__content--visual')
        .classList.remove('manifesto__content--visual');
      manifesto.querySelector(`#${itemId}`).classList.add('manifesto__content--visual');

      manifesto
        .querySelector('.manifesto-images--visual')
        .classList.remove('manifesto-images--visual');
      manifesto.querySelector(`#${itemId}-img`).classList.add('manifesto-images--visual');
    });

    const blocks = manifesto
      .querySelector(`#${itemId}`)
      .querySelectorAll('.js-manifesto-content-block');
    const photos = manifesto
      .querySelector(`#${itemId}-img`)
      .querySelectorAll('.manifesto-images__image');

    blocks.forEach((block, index) => {
      const text = block.querySelector('.manifesto-cards__card-text');
      const title = block.querySelector('.manifesto-cards__card-title');
      if (index == 0) {
        text.classList.add('manifesto-cards__card-text--active');
      }

      block.addEventListener('click', () => {
        blocks.forEach((block) => {
          block
            .querySelector('.manifesto-cards__card-text')
            .classList.remove('manifesto-cards__card-text--active');
          block
            .querySelector('.manifesto-cards__card-title')
            .classList.remove('manifesto-cards__card-title--active');
        });
        photos.forEach((photo) => {
          photo.classList.remove('manifesto-images__image--active');
        });

        text.classList.add('manifesto-cards__card-text--active');
        title.classList.add('manifesto-cards__card-title--active');
        manifesto
          .querySelector(`#${block.id}-img`)
          .classList.add('manifesto-images__image--active');
      });
    });
  });
}

export { initializeManifesto };
